'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useCallback } from 'react';
import ComingSoonCover from '@/components/ComingSoonCover';
import { DeviceAssignmentRuleContent } from '@/features/device-assignment-rule/components';
import { DeviceGroupCombobox } from '@/features/device-group/components/DeviceGroupCombobox';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { featureFlags } from '@/lib/env';
import { defaultNS, useTranslation } from '@/lib/i18n';
import placeholderRuleAndPolicy from '../-assets/placeholder-rule-and-policy.png';
import { DEVICE_ASSIGNMENT_FEATURE_FLAG } from '../-constants/featureFlags';
import { DeviceAssignmentRuleShell } from './-components/DeviceAssignmentRuleShell';
import { RuleAndPolicySearchSchema, type RuleAndPolicySearch } from './-zod-schema';
export const Route = createFileRoute('/_staff/devices/_list/rule-and-policy/')({
  validateSearch: zodValidator(RuleAndPolicySearchSchema),
  component: RouteComponent
});
function RouteComponent() {
  // 本番非公開: FeatureFlag OFF の間は ComingSoonCover を表示し、実装へは遷移させない
  if (!featureFlags.check(DEVICE_ASSIGNMENT_FEATURE_FLAG)) {
    return <ComingSoonCover placeholderImage={placeholderRuleAndPolicy} />;
  }
  return <RuleAndPolicyContent />;
}
function RuleAndPolicyContent() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.devices.ruleAndPolicy'
  });
  useDocumentTitle(t('pageTitle'));
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const handleListFilterChange = useCallback((patch: {
    search?: string;
    filterPgId?: string;
    filterDgId?: string;
  }) => {
    navigate({
      // フィルタは onChange ごとに発火するため replace で history を積まない
      replace: true,
      search: (prev: RuleAndPolicySearch) => ({
        ...prev,
        search: patch.search !== undefined ? patch.search || undefined : prev.search,
        peopleGroupId: patch.filterPgId !== undefined ? patch.filterPgId || undefined : prev.peopleGroupId,
        deviceGroupId: patch.filterDgId !== undefined ? patch.filterDgId || undefined : prev.deviceGroupId
      })
    });
  }, [navigate]);
  return <DeviceAssignmentRuleShell>
      <DeviceAssignmentRuleContent listFilter={{
      search: search.search ?? '',
      filterPgId: search.peopleGroupId ?? '',
      filterDgId: search.deviceGroupId ?? ''
    }} onListFilterChange={handleListFilterChange} renderDeviceGroupFilter={props => <DeviceGroupCombobox {...props} allowClear emptyLabel={t('filter.all')} searchPlaceholder={t('form.deviceGroupSearchPlaceholder')} noResultsMessage={t('form.deviceGroupNoResults')} className="w-[180px]" />} />
    </DeviceAssignmentRuleShell>;
}